

















import { ref, defineComponent, computed, watch } from '@nuxtjs/composition-api'
import Pagination from 'vuejs-paginate/src/components/Paginate'

export default defineComponent({
  name: 'PaginationList',
  components: {
    Pagination,
  },
  props: {
    total: {
      type: Number,
      default: 0,
    },
    itemsPerPage: {
      type: Number,
      default: 0,
    },
    activePage: {
      type: Number,
      default: 0,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const { emit } = ctx
    const pageRange = ref<number>(props.isMobile ? 3 : 5)
    const paginationModel = ref<number>(1)

    const countPages = computed<number>(() => {
      return Math.ceil(props.total / props.itemsPerPage)
    })

    const onPaginationChange = (page: number): void => {
      emit('change', page)
    }

    watch(
      props,
      (newProps): void => {
        paginationModel.value = JSON.parse(JSON.stringify(newProps.activePage))
      },
      { immediate: true }
    )

    return {
      paginationModel,
      countPages,
      pageRange,
      onPaginationChange,
    }
  },
})
